import { makeStyles } from '@mui/styles';

const useStyles: any = makeStyles((theme: any) => ({
  fieldStyle: {
    width: "100%"
  },
  descriptionField: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexFlow: "column nowrap",
    "& .MuiFormControl-root": {
      flex: 1
    },
    "& .MuiInputBase-root": {
      flex: 1,
      alignItems: "flex-start",
      height: "auto"
    },
    "& .MuiInputBase-input": {
      height: "100% !important",
      overflow: "auto",
      resize: "none"
    }
  },
  fieldLabel: {
    width: "100%",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#7f7182",
    marginBottom: "10px"
  },
  fieldsContainer: {
    display: "flex",
    width: "100%",
    flexFlow: "column nowrap",
    justifyContent: "center",
    alignItems: "center",
    overflowX: "hidden",
    marginTop: "20px"
  },
  twoFieldsRow: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    gap: "20px",
    width: "100%"
  },
  smallField: {
    width: "48%"
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "flex-end"
  },
  sharedButtonStyle: {
    width: "90px",
    height: "40px",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: 500,
    margin: "15px 10px",
    marginBottom: "15px",
    padding: "0"
  },
  submitButton: {
    backgroundImage: theme.gradiants.button || "linear-gradient(to left, #421a40 100%, #29132e 0%)",
    color: "#fdfdfe",
    "&.Mui-disabled": {
      color: "#fdfdfe",
      opacity: 0.8,
    }
  },
  uploadContainer: {
    width: "100%",
    marginTop: "15px",
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "flex-start"
  },
  uploadButton: {
    marginTop: "5px"
  },
  fileNameText: {
    fontSize: "13px",
    color: "#7f7182",
    marginTop: "8px"
  },
  fileError: {
    fontSize: "12px",
    color: "red",
    marginTop: "8px"
  },
  contentArea: {
    width: "100%",
    minHeight: 400,
    display: "flex",
    flexFlow: "column nowrap"
  },
  loader: {
    width: 60,
    height: 60
  },
  loaderContainer: {
    width: "100%",
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
}));

export default useStyles;
